export default __webpack_public_path__ + "static/media/user-160.b2adc4a5.svg";